import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import styled from 'styled-components'
import { breakpoints, HideOverflow } from 'src/utils/styles/global-styles'
import { withTranslation } from 'gatsby-plugin-react-i18next'
import { graphql } from 'gatsby'
import StoreContext from 'src/context/StoreContext'
import SEO from '../components/seo'
import Analytics from '../utils/Analytics'
import FAQs from '../components/FAQs'
import PressTestimonials from '../components/PressTestimonials'
// import HomepageCalHero from '../components/HomepageCalHero'
import CalMaxHero from '../components/CalMaxHero'

import HomepageProducts from '../components/HomepageProducts'
import FramePage from './frame'
import RedesignCalendarTestimonials from '../components/RedesignCalendarTestimonials'
import PressBanner from '../components/PressBanner'
import TrustedBy from '../components/TrustedBy'
import {
  IN_AU,
  IN_CA,
  IN_UK,
  // IS_FOREIGN_COUNTRY,
  LOCALIZATION,
  CAL_BUY_LINK,
  IN_SEASONAL_STATE,
  SEASONAL_STATES,
  CURRENT_SEASONAL_STATE,
  VIP_CODE,
  COUNTDOWN_EXPIRATIONS,
} from '../utils/constants'
import CountDownTimer from '../components/CountDownTimer'
import SeasonalCountdownTimer from '../components/SeasonalCountdownTimer'

const SHOW_UNIFIED_HOMEPAGE = process.env.GATSBY_SHOW_UNIFIED_HOMEPAGE
class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isCountdownVisible: false,
      countdownData: IN_SEASONAL_STATE
        ? COUNTDOWN_EXPIRATIONS?.bfcm
        : props?.data?.countdown?.edges?.[0]?.node,

      countdownCountry: `${LOCALIZATION}_countdown`,
    }

    this.handleCountdownComplete = this.handleCountdownComplete.bind(this)
    this.renderCountdown = this.renderCountdown.bind(this)
  }

  componentDidMount() {
    Analytics.track('Viewed Homepage')
    const { countdownData, countdownCountry } = this.state
    const {
      store: {
        banner: { promoCode },
      },
    } = this.context
    const showCountdown = promoCode === VIP_CODE
    const holidayDate = countdownData?.[countdownCountry] || countdownData?.en_countdown
    const hasHoliday = holidayDate && holidayDate !== 'NONE'
    if (showCountdown || hasHoliday) {
      this.setState({ isCountdownVisible: true })
    }
    const { checkUtmParamsForPromo } = this.context
    checkUtmParamsForPromo(window.location.search)
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      store: {
        banner: { promoCode },
      },
    } = this.context
    const showCountdown = promoCode === VIP_CODE
    if (showCountdown && !prevState.isCountdownVisible) {
      this.setState({ isCountdownVisible: true })
    }
  }

  handleCountdownComplete() {
    this.setState({ isCountdownVisible: false })
  }

  renderCountdown(holidayDate) {
    const { bfcmCore, vip } = SEASONAL_STATES

    if (IN_SEASONAL_STATE) {
      return (
        <SeasonalCountdownTimer
          holidayDate={holidayDate}
          holidayState={CURRENT_SEASONAL_STATE ?? bfcmCore}
          onCountdownComplete={this.handleCountdownComplete}
        />
      )
    }

    const {
      store: {
        banner: { promoCode },
      },
    } = this.context

    if (promoCode === VIP_CODE) {
      return (
        <SeasonalCountdownTimer
          holidayDate={holidayDate}
          holidayState={vip}
          onCountdownComplete={this.handleCountdownComplete}
        />
      )
    }
    return (
      <CountDownTimer
        holidayDate={holidayDate}
        onCountdownComplete={this.handleCountdownComplete}
        ctaLinkOverride={CAL_BUY_LINK}
      />
    )
  }

  render() {
    const {
      store: {
        banner: { promoCode },
      },
    } = this.context
    const { t, data } = this.props
    const { countdownData, countdownCountry, isCountdownVisible } = this.state
    const { ogCalAndFrameImage } = data

    const showHomepageHero = IN_AU || IN_CA || IN_UK
    const isVIPState = promoCode === VIP_CODE && !IN_SEASONAL_STATE

    const vipHolidayDate = isVIPState ? COUNTDOWN_EXPIRATIONS?.vip?.[countdownCountry] : null
    const holidayDate =
      vipHolidayDate ?? (countdownData?.[countdownCountry] || countdownData?.en_countdown)
    const heroVersion = IN_SEASONAL_STATE || isVIPState ? 'bfcm' : null

    if (!SHOW_UNIFIED_HOMEPAGE || SHOW_UNIFIED_HOMEPAGE === 'false') {
      return (
        <>
          <SEO
            title={t('Skylight Frame')}
            description={t(
              'Skylight is a WiFi-enabled, touchscreen digital frame that lets you easily send pictures to your loved ones by email or mobile app.'
            )}
            canonicalPath="/"
            path="/"
          />
          <FramePage
            t={t}
            seoAlreadyDefined
            showHomepageHero={showHomepageHero}
            data={data}
            page={CURRENT_SEASONAL_STATE === 'bau' ? 'bau' : heroVersion}
          />
        </>
      )
    }

    return (
      <>
        <SEO
          title={t('Skylight Calendar & Frame | Smart Calendar & Digital Picture Frame')}
          description={t(
            'Skylight Calendar and Frame keep families connected with shareable photos, schedules, and more.'
          )}
          canonicalPath="/"
          path="/"
          imagePath={ogCalAndFrameImage.childImageSharp.gatsbyImageData.images.fallback.src}
        />
        <Helmet>
          <meta charset="UTF-8" />
          <link
            rel="stylesheet"
            type="text/css"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
          />
          <link
            rel="stylesheet"
            type="text/css"
            href="//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css"
          />
        </Helmet>
        <HideOverflow>
          {/* <HomepageCalHero page={CURRENT_SEASONAL_STATE === 'bau' ? 'bau' : heroVersion} /> */}
          <CalMaxHero homepage />
          <PressBanner />
          {isCountdownVisible &&
            holidayDate &&
            holidayDate !== 'NONE' &&
            this.renderCountdown(holidayDate)}
          <HomepageProducts inSeasonalState={IN_SEASONAL_STATE || isVIPState} />
          <PressTestimonials page="frame" bottom="80px;" top="0px 0px 20px;" />
          <TrustedBy />
          <HideOverflow>
            <RedesignCalendarTestimonials />
          </HideOverflow>
          <FAQs page="unified" />
        </HideOverflow>
      </>
    )
  }
}

IndexPage.propTypes = {
  t: PropTypes.func,
  data: PropTypes.object,
}

IndexPage.contextType = StoreContext
export default withTranslation()(IndexPage)

export const DisplayOnMobile = styled.div`
  display: none;
  @media (max-width: ${breakpoints.s}px) {
    display: block;
  }
`

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { ns: { in: ["common", "index"] }, language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    countdown: allContentfulCountdownTimer {
      edges {
        node {
          en_au_countdown
          en_ca_countdown
          en_countdown
          en_gb_countdown
        }
      }
    }
    ogCalAndFrameImage: file(relativePath: { eq: "meta-seo/cal-and-frame-1.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    frameProductsImage: file(relativePath: { eq: "meta-seo/frame-products-logo.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    mdFrameProduct: file(relativePath: { eq: "md2026/frame_hp_desk.webp" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
  }
`
